import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import ContainerLayout from "../../../layouts/two-columns/container-layout";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import LoadingComp from "../../../components/re-usable/loading/loading";
import VolunteerOpportunitiesListing from "./component/volunteer-listing.component";
import { useDynamicScripts } from "../../../hooks/useDynamicScript";

const VolunteerOpportunities = () => {
  const path = "Membership%2FVolunteer-Opportunities";
  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField)
        setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
    if (typeof window !== "undefined" && window.runGlobalScripts) {
      window.runGlobalScripts();
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <ContainerLayout breadcrumbPath={path} isBreadcrumbPath={true} showAds={true} showSocialMedia={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
        <VolunteerOpportunitiesListing />
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
      </ContainerLayout>
    </>
  );
}

export default VolunteerOpportunities